import React from "react";
import { CaretRight, CaretLeft } from "phosphor-react";
import PaginationComponent from "rc-pagination";
import "./index.scss";
const prevIcon = (
  <p className="page-link icon-otr">
    <CaretLeft size={20} />
  </p>
);

const nextIcon = (
  <p className="page-link icon-otr">
    <CaretRight size={20} />
  </p>
);
const Pagination = ({ itemsCount, currentPage, onPageChange, pageSize }) => {
  return (
    <div className="pagination-main">
      <nav aria-label="...">
        <ul className="pagination">
          <PaginationComponent
            className="pagination"
            onChange={onPageChange}
            current={currentPage}
            total={itemsCount}
            pageSize={pageSize}
            showTitle={false}
            hideOnSinglePage
            showLessItems
            showSizeChanger={false}
            itemRender={(current, type, element) => (
              <p className="page-link page-linkk-otr">
                <span className="page-linkk heading-xsb">{element}</span>
              </p>
            )}
            prevIcon={prevIcon}
            nextIcon={nextIcon}
          />
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
